<template>
  <div class="album-image-warning" role="img" aria-label="图片加载失败">
    <i class="fa-solid fa-triangle-exclamation" aria-hidden="true" />
  </div>
</template>

<style scoped>
.album-image-warning {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  background: var(--empty-bg);
  color: var(--text-soft);
  font-size: 32px;
  pointer-events: none;
}
</style>
